export enum LocalStorageKeys {
  LANGUAGE = 'i18nLanguage',
  NAVBAR_COLLAPSED = 'navbarCollapsed',
}
